export class Constant {
  public static POPULAR = "mostPopular";
  public static DIVIDENT_PAYING = "topDividendPaying";
  public static GROWTH = "topGrowth";
  public static FOLLOWING = "FOLLOWING";

  public static BUY = "buy";
  public static SELL = "sell";

  public static STOCK = "STOCK";
  public static ETF = "ETF";

  public static CONTINUE = "Continue";
  public static SUSPENDED = "Suspended";

  public static APPLICATION = "APPLICATION";
  public static INVESTIGATIONS = "INVESTIGATIONS";

  public static POST_SUCCESS_REFRESH_DELAY_MS = 3000;

  public static ENV = process.env.REACT_APP_ENVIRONMENT || "production";

}
